/**
 * Checks if a string contains only phone number characters.
 *
 * SIP headers sometimes send the phone number in the displayName field
 * instead of an actual name. This function detects that pattern to avoid
 * showing unformatted numbers as contact names.
 *
 * @param value - The string to check (e.g., SIP displayName)
 * @returns true if the string appears to be a phone number
 *
 * @example
 * isPhoneNumberString('351913531226')     // true
 * isPhoneNumberString('+1 (555) 123-4567') // true
 * isPhoneNumberString('John Smith')        // false
 * isPhoneNumberString('Bayonne Nj')        // false
 */
export function isPhoneNumberString(
  value: string | undefined | null
): boolean {
  if (!value) return false;
  // eslint-disable-next-line no-useless-escape
  return /^[\d\s\-\+\(\)]+$/.test(value.trim());
}
